import useAxios from "../../plugins/useAxios"
import { useNavigate } from "react-router-dom";

const SiteCard = ({item}) => {
    const navigate = useNavigate();

    const selectSite = () => {
        localStorage.setItem('site', item.tagName)
        console.log(localStorage.getItem('site', item.tagName))
        navigate('/events/in')
    }

    return (
        <div
            onClick={() => selectSite()}
            className="group relative bg-white rounded-2xl overflow-hidden cursor-pointer transition-all duration-300 hover:scale-105 hover:shadow-2xl border-2 border-transparent hover:border-blue-500"
        >
            {/* Immagine o placeholder */}
            <div className="h-48 bg-gradient-to-br from-blue-500 to-purple-600 relative overflow-hidden">
                {item.image ? (
                    <img
                        src={useAxios.getUri().replace('/api/', '') + item.image}
                        alt={item.title}
                        className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-300"
                    />
                ) : (
                    <div className="w-full h-full flex items-center justify-center">
                        <i className="pi pi-building text-white text-6xl opacity-50"></i>
                    </div>
                )}
                {/* Overlay gradient */}
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent"></div>

                {/* Badge status */}
                <div className="absolute top-4 right-4 bg-green-500 text-white px-3 py-1 rounded-full text-xs font-semibold flex items-center gap-1">
                    <span className="w-2 h-2 bg-white rounded-full animate-pulse"></span>
                    Attivo
                </div>
            </div>

            {/* Content */}
            <div className="p-6">
                <h3 className="text-2xl font-bold text-gray-800 mb-2 group-hover:text-blue-600 transition-colors">
                    {item.title}
                </h3>
                <p className="text-gray-600 text-sm mb-4">
                    {item.description || 'Nessuna descrizione disponibile'}
                </p>

                {/* Footer con tag */}
                <div className="flex items-center justify-between pt-4 border-t border-gray-100">
                    <span className="text-xs text-gray-400 font-mono">
                        {item.tagName}
                    </span>
                    <div className="flex items-center gap-2 text-blue-600 font-semibold text-sm group-hover:gap-3 transition-all">
                        Seleziona
                        <i className="pi pi-arrow-right"></i>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default SiteCard;